import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";

import "./history.scss";
import Loader from "../../components/loader/loader";
import Header from "../../components/header/header";
import HotelCard from "../../components/hotel-card/hotel-card";
import { pageUrl } from "../../utils/pageConstant";
import GetBookingInfoAPI from "../../services/GetBookingInfo/GetBookingInfo";
import { handleOutletName } from "../../utils";

const History = () => {
  const [isLoader, setIsLoader] = useState(true);
  const [orderHistoryDetails, setorderHistoryDetails] = useState([]);
  const navigate = useNavigate();

  const handleBack = () => {
    navigate(pageUrl.PROFILE);
  };

  const handleNext = (details) => {
    navigate(pageUrl.PAYMENT_SUMMARY, {
      state: { bookingInfo: details },
    });
  };

  useEffect(() => {
    getOrderHistoryDetails();
  }, []);

  const getOrderHistoryDetails = async () => {
    try {
      const responseData = await GetBookingInfoAPI();
      setorderHistoryDetails(responseData);
      localStorage.setItem("outletDetailsInfo", JSON.stringify(responseData));
      setIsLoader(false);
    } catch (error) {}
  };

  return (
    <div className="paybill-page">
      {isLoader && <Loader />}
      <div className="top-section">
        <Header label="Order History" onClick={handleBack} />
      </div>
      <div className="hotel-section">
        {orderHistoryDetails?.map((outlet, index) => {
          return (
            <>
              <HotelCard
                key={index}
                imgSrc={outlet?.outletMedias[0]?.mediaPath}
                name={outlet?.outletName}
                detail={outlet?.localCouponDetails[0]?.orderDate}
                // amount={outlet?.localCouponDetails[0]?.totalAmtPaid}
                amount={outlet?.localCouponDetails[0]?.amount}
                onClick={() => handleNext(outlet)}
              />
            </>
          );
        })}
      </div>
    </div>
  );
};

export default History;
